import * as swcHelpers from '@swc/helpers';
import { actions, idleState, loadingState, failedState } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import { startConfigurator, nextStep, nextStepSuccess, previousStepSuccess, resetStepVisited, toggleFooter, closeFooter, openFooter, finish, finishFailed, finishSuccess } from './actions.js';

var ref;
const createInitialConfiguratorState = (stateOverrides)=>{
    var ref1;
    return swcHelpers.objectSpread({
        currentStep: 0,
        stepSequence: [],
        stepsAttempted: new Set(),
        stepsVisited: [
            (ref = stateOverrides === null || stateOverrides === void 0 ? void 0 : (ref1 = stateOverrides.stepSequence) === null || ref1 === void 0 ? void 0 : ref1[0]) !== null && ref !== void 0 ? ref : ''
        ],
        calls: {
            finish: idleState()
        },
        isFooterOpen: false
    }, stateOverrides);
};
const setStateById = (state, id, cb)=>{
    const configuratorState = state[id];
    return configuratorState ? swcHelpers.objectSpread({}, state, {
        [id]: swcHelpers.objectSpread({}, configuratorState, cb(configuratorState))
    }) : state;
};
const initialState = {};
var _stepsAttempted;
const reducer = actions.reducer(initialState, /**
   * Set the correct productSku and always reset the configurator to the initial state
   */ actions.on(startConfigurator, (s, { payload: { id , stepSequence  }  })=>swcHelpers.objectSpread({}, s, {
        [id]: swcHelpers.objectSpread({}, createInitialConfiguratorState({
            stepSequence
        }))
    })
), /**
   * When user tries to move on to the next step record so we mark the form as submitted
   *
   * This will reveal validation errors
   */ actions.on(nextStep, (s, { payload: { id  }  })=>setStateById(s, id, (c)=>swcHelpers.objectSpread({}, c, {
            stepsAttempted: new Set([
                ...(_stepsAttempted = c.stepsAttempted) !== null && _stepsAttempted !== void 0 ? _stepsAttempted : [],
                c.currentStep
            ])
        })
    )
), /**
   * When the steps change is allowed it's communicated by dispatching the nextStepSuccess action
   */ actions.on(nextStepSuccess, (s, { payload: { id , newStep  }  })=>setStateById(s, id, (c)=>{
        const newStepsVisited = new Set([
            ...c.stepsVisited,
            c.stepSequence[newStep]
        ].filter(isDefined));
        return swcHelpers.objectSpread({}, c, {
            currentStep: newStep,
            stepsVisited: [
                ...newStepsVisited
            ]
        });
    })
), /**
   * When the current step is moved back it's communicated by dispatching the previousStepSuccess action
   *
   * When user returns from step 3 to step 2, both 3 (currentStep) and 2 (newStep) are removed so we don't show error messages when returning
   */ actions.on(previousStepSuccess, (s, { payload: { id , currentStepNumber , newStep  }  })=>setStateById(s, id, (c)=>swcHelpers.objectSpread({}, c, {
            currentStep: newStep,
            stepsAttempted: new Set([
                ...c.stepsAttempted
            ].filter((step)=>step !== currentStepNumber && step !== newStep
            ))
        })
    )
), actions.on(resetStepVisited, (s, { payload: { id , step  }  })=>setStateById(s, id, (c)=>{
        const newStepsVisited = c.stepsVisited.filter((visitedStep)=>visitedStep !== step
        );
        return swcHelpers.objectSpread({}, c, {
            stepsVisited: newStepsVisited
        });
    })
), /**
   * Toggles footer
   */ actions.on(toggleFooter, (s, { payload: { id  }  })=>setStateById(s, id, (c)=>swcHelpers.objectSpread({}, c, {
            isFooterOpen: !c.isFooterOpen
        })
    )
), actions.on(closeFooter, (s, { payload: { id  }  })=>setStateById(s, id, (c)=>swcHelpers.objectSpread({}, c, {
            isFooterOpen: false
        })
    )
), actions.on(openFooter, (s, { payload: { id  }  })=>setStateById(s, id, (c)=>swcHelpers.objectSpread({}, c, {
            isFooterOpen: true
        })
    )
), /**
   * Tracks the status of the finish call
   */ actions.on(finish, (s, { payload: { id  }  })=>setStateById(s, id, (c)=>swcHelpers.objectSpread({}, c, {
            calls: swcHelpers.objectSpread({}, c.calls, {
                finish: loadingState()
            })
        })
    )
), actions.on(finishFailed, (s, { payload: { id , reason  }  })=>setStateById(s, id, (c)=>swcHelpers.objectSpread({}, c, {
            calls: swcHelpers.objectSpread({}, c.calls, {
                finish: failedState(reason)
            })
        })
    )
), actions.on(finishSuccess, (s, { payload: { id  }  })=>setStateById(s, id, (c)=>swcHelpers.objectSpread({}, c, {
            calls: swcHelpers.objectSpread({}, c.calls, {
                finish: idleState()
            })
        })
    )
));

export { initialState, reducer };
//# sourceMappingURL=reducer.js.map
